import gql from 'graphql-tag';
import { CORE_USER_FIELDS } from '../fragments';
import { ME_USER_FIELDS } from '~/graphql/fragments';

export const CREATE_USER = gql`
    mutation createUser(
        $role: String!,
        $email: String!,
        $first_name:String!,
        $name: String!,
        $password: String,
        $password_confirmation: String
        $language: UserLanguage
        $authMode: AuthMode
    ) {
        createUser(
            input: {
                role: $role
                email: $email
                firstName: $first_name
                name: $name
                password: $password
                passwordConfirmation: $password_confirmation
                language: $language
                authMode: $authMode
            }
        ) {
            ...CoreUserFields
        }
    }
    ${CORE_USER_FIELDS}
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $role: String,
    $first_name:String!,
    $name: String!
    $notification_mode: String
    $email: String
    $password: String,
    $password_confirmation: String,
    $language: UserLanguage
    $categorizationAuto: Boolean
    $authMode: AuthMode
  ) {
    updateUser(
      input: {
        id: $id
        role: $role
        authMode: $authMode
        firstName: $first_name
        name: $name
        notificationMode: $notification_mode
        email: $email
        password: $password
        passwordConfirmation: $password_confirmation
        language: $language
        categorizationAuto: $categorizationAuto
      }
    ) {
      ...CoreUserFields
    }
  }
  ${CORE_USER_FIELDS}
`;

export const DELETE_USER = gql`
    mutation deleteUser(
        $id: ID!
    ) {
        deleteUser(
            input: {
                id: $id
            }
        )
    }
`;

export const UPDATE_ME = gql`
  mutation updateMe(
    $language: UserLanguage
    $startingDashboard: String
    $firstLogin: DateTime
  ) {
    updateMe(
      input: {
        language: $language
        startingDashboard: $startingDashboard
        firstLogin: $firstLogin
      }
    ){
      ...MeUserFields
    }
  }
  ${ME_USER_FIELDS}
`;

export const UPDATE_MY_AVATAR = gql`
  mutation updateMyAvatar(
    $avatar: Upload
  ) {
    updateMyAvatar(
      input: {
        avatar: $avatar
      }
    ){
      id
    }
  }
`;
